import { isOnline } from './is-online';
import { BehaviorSubject, defer, interval, Observable, switchMap } from 'rxjs';

let initialValue: boolean | null = null;

export const online$ = new BehaviorSubject<boolean>(false);

export const onlineInitialized$: Observable<boolean> = defer(async () => {
  if (initialValue === null) {
    // Call the isOnline function only once
    initialValue = await isOnline({ timeout: 2000 });
    online$.next(initialValue);
  }
  // On subsequent subscriptions, immediately emit true
  return true;
});

// @ts-ignore
if (typeof window !== 'undefined' && typeof Worker !== 'undefined' && !(self instanceof Worker)) {
  interval(5000)
    .pipe(switchMap(() => isOnline({ timeout: 3000 })))
    .subscribe((online) => online$.next(online));
}
